import { ACTIONS } from './actions'
import { COMPONENTS } from './components'
import { CONTAINERS } from './containers'
import { EVENTS } from './events'
import { CONFIG } from './config'

export const CONSTANTS = {
  ACTIONS, COMPONENTS, CONTAINERS, EVENTS, CONFIG
}
